/**
 * Profile display helpers (My Profile page).
 */

export const formatProfileDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatProfileDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const resolveProfileImageUrl = (profileImage) => {
  if (!profileImage || !String(profileImage).trim()) return null;
  const src = String(profileImage).trim();
  if (/^(https?:|data:|blob:)/i.test(src)) return src;
  const apiBase = process.env.REACT_APP_API_URL || "";
  const origin = apiBase.replace(/\/api\/v\d+\/?$/i, "").replace(/\/$/, "");
  const path = src.startsWith("/") ? src : `/${src}`;
  return `${origin}${path}`;
};

export const normalizeProfileResult = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  return {
    userName: raw.userName ?? raw.UserName ?? "",
    roleName: raw.roleName ?? raw.RoleName ?? "",
    emailId: raw.emailId ?? raw.EmailId ?? "",
    contactNo: raw.contactNo ?? raw.ContactNo ?? "",
    profileImage: raw.profileImage ?? raw.ProfileImage ?? "",
    registeredOn: raw.registeredOn ?? raw.RegisteredOn ?? "",
    log_time: raw.log_time ?? raw.logTime ?? raw.LogTime ?? "",
    log_ip: raw.log_ip ?? raw.logIp ?? raw.LogIp ?? "",
    status: raw.status ?? raw.Status ?? "",
    doj: raw.doj ?? raw.Doj ?? raw.dateOfJoining ?? raw.DateOfJoining ?? "",
  };
};
